App.filter('dictionaryFilter', function () {
    return function (el) {
        el = el || '';

        var dictionary = [];
        
        dictionary['ENTERED'] = 'wprowadzony';
        dictionary['EXPIRED'] = 'wygaszony';
        dictionary['DELETED'] = 'usunięty';
        dictionary['READY'] = 'zawarty';
        dictionary['ACTIVE'] = 'aktywny';
        dictionary['CANCELED'] = 'anulowany';
        dictionary['WITHDRAWN'] = 'wystąpienie';
        dictionary['ENDED'] = 'zakończony';

        if (el) {
        	if (dictionary[el]) {
        		return dictionary[el];
        	} else {
        		return el;
        	}
        }

        return el;
    };
})